import { useEffect, useState } from "react";
import { auth, db } from "../Firebase";
import ReviewPopup from "../Components/ReviewPopup";

import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  deleteDoc
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import "../styles/MyCourse.css";

const MyCourse = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);


  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setCourses([]);
        setLoading(false);
        return;
      }

      try {
        const ordersSnap = await getDocs(
          query(
            collection(db, "orders"),
            where("userId", "==", user.uid)
          )
        );

        const list = [];

        for (const order of ordersSnap.docs) {
          const orderData = order.data();

          // 🔹 Course data
          const courseSnap = await getDoc(
            doc(db, "courses", orderData.courseId)
          );

          if (!courseSnap.exists()) continue;

          const course = courseSnap.data();

          // 🔹 COURSE TIMING (PROGRESS SOURCE)
  const timingSnap = await getDoc(
    doc(db, "courseTiming", `${user.uid}_${courseSnap.id}`)
  );

  const progress = timingSnap.exists()
    ? Math.min(
        Math.max(timingSnap.data().progressPercentage || 0, 0),
        100
      )
    : 0;

          // Review (stars only)
          const reviewSnap = await getDoc(
            doc(db, "reviews", `${courseSnap.id}_${user.uid}`)
          );

          const review = reviewSnap.exists()
            ? reviewSnap.data()
            : null;

          list.push({
            id: courseSnap.id,
            ...course,
            boughtPrice: orderData.pricePaid || 0,
            progress,
            review
          });
        }

        setCourses(list);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load courses");
      } finally {
        setLoading(false);
      }
    });

    return () => unsub();
  }, []);

  if (loading) {
    return <p align="center">Loading…</p>;
  }

  return (
    <div className="mycourses-page">
      <h1>My Courses</h1>

      {courses.length === 0 && (
        <p>You have not enrolled in any course.</p>
      )}

      <div className="mycourses-grid">
        {courses.map((course) => (
          <div key={course.id} className="mycourse-card">
            <img
              src={course.thumbnail}
              alt={course.title}
              onClick={() =>
                navigate(`/myCourseDetails/${course.id}`)
              }
            />

            <div className="course-info">
              <h3 onClick={() =>
                    navigate(
                      `/myCourseDetails/${course.id}`
                    )
                  }>{course.title}</h3>

              {/*  STAR RATING ONLY */}
              {course.review && (
                <div className="mycourse-review" onClick={() => {
                  setSelectedCourse(course.id);
                  setShowReviewModal(true);
                }}>
                  <div className="star-row readonly">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className={`star ${
                          course.review.rating >= star
                            ? "active"
                            : ""
                        }`}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="course-meta-crs">
                <span>Price: ₹{course.price}</span>
                <span className="progress-prcnt">Bought: ₹{course.boughtPrice}</span>
              </div>

              <div className="progress-wrapper">
              <div className="progress-bar" style={{ width: `${course.progress}%` }} /></div>
              <div className="progress-text">
                <span>Duration: {course.duration}</span>
                <span className="progress-prcnt"> {course.progress}% </span>
              </div>
              <div className="course-actions">
                <button
                  className="continue-btn"
                  onClick={() =>
                    navigate(
                      `/myCourseDetails/${course.id}`
                    )
                  }
                >
                  Continue
                </button>

                {course.progress === 100 && (
                  <button
                    className="certificate-btn"
                    onClick={() =>
                      navigate(
                        `/uploadCertificate/details/${course.id}`
                      )
                    }
                  >
                    Certificate
                  </button>
                )}

                <button
                  className="unsubscribe-btn"
                  onClick={async () => {
                    if (
                      !window.confirm(
                        "Unsubscribe from course?"
                      )
                    )
                      return;

                    await deleteDoc(
                      doc(
                        db,
                        "orders",
                        `${auth.currentUser.uid}_${course.id}`
                      )
                    );

                    setCourses((prev) =>
                      prev.filter(
                        (c) => c.id !== course.id
                      )
                    );

                    toast.success(
                      "Unsubscribed successfully"
                    );
                  }}
                >
                  Unsubscribe
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* REVIEW POPUP MUST BE HERE */}
      {showReviewModal && (
        <ReviewPopup
          courseId={selectedCourse}
          onClose={() => setShowReviewModal(false)}
        />
      )}
    </div>
  );
};

export default MyCourse;
